import { ValidatorFn } from '@angular/forms';
import {
  FormFieldSaveBind,
  IFormFieldSaveBind,
} from './form-field-save-bind.model';

export interface IFormField extends IFormFieldSaveBind {
  label: string;
  type: string;
  url?: string;
  optionLabel?: string;
  optionValue?: string;
  validators: ValidatorFn[];
}

export class FormField extends FormFieldSaveBind implements IFormField {
  label: string;
  type: string;
  url?: string;
  optionLabel?: string;
  optionValue?: string;
  validators: ValidatorFn[];

  constructor();
  constructor(obj: IFormField);
  constructor(obj?: IFormField) {
    super(obj as IFormFieldSaveBind);
    this.label = obj?.label ?? '';
    this.type = obj?.type ?? '';
    this.url = obj?.url;
    this.optionLabel = obj?.optionLabel;
    this.optionValue = obj?.optionValue;
    this.validators = obj?.validators ?? [];
  }
}
